import type {$Fetch} from "nitropack";
import baseRepository from "~/api/BaseRepository";
import type { ScoreBreakdown } from "~/api/v2/experts/ExpertRepository";

export enum InvitationStatus {
    Denied = 'denied',
    Applied = 'applied',
    Preapproved = 'preapproved',
    Accepted = 'accepted',
    TooLate = 'toolate',
    Created = 'created',
    Invited = 'invited',
}

export interface Invitation {
    invitation_id: string;
    status: InvitationStatus;
    user: {
        user_id: string;
        first_name: string;
        last_name: string;
        profile: {
            picture: string | null;
            picture_url: string | null;
            slug: string
        }
    };
    score?: number | null;
    score_breakdown?: ScoreBreakdown | null;
}

interface CreateInvitationPayload {
    mission_id: string;
    user_id: string;
}

export const InvitationRepository = (client: $Fetch) => ({
    ...baseRepository(client)('v1/invitations'),

    update: (invitationId: string, status: InvitationStatus) => {
        return client(`/v1/invitations/${invitationId}/${status}`, {
            method: 'POST'
        }) as Promise<Invitation>;
    },

    fetchInvitations: (missionId: string) => {
        return client(`/v1/missions/${missionId}/invitations`, {
            method: 'GET',
        }) as Promise<Invitation[]>;
    },

    // Count invitations awaiting the current user's response (status `invited`).
    // Powers the expert-side "you have N pending invitations" banner.
    countMine: () => {
        return client(`/v1/me/invitations/count`, {
            method: 'GET',
        }) as Promise<{ count: number }>;
    }
})